import React, { Component } from "react";
import { FormControlLabel, InputAdornment, OutlinedInput, Radio, RadioGroup } from "@mui/material";
import { withLocalizer } from "utilities/withLocalizer";
import { CONSTANTS } from "utilities/constants";
import commonUtilities from "utilities/common";
import { CONFIGURATION } from "utilities/configuration";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";

import "../../../customize.scss";

class Markup extends Component {
    constructor(props) {
        super(props);
        const markupType = this.props?.data?.markup?.type || CONSTANTS.MARKUP_TYPE_PERCENT;
        this.state = {
            adult: this.props?.data?.markup?.adult || undefined,
            child: this.props?.data?.markup?.child || undefined,
            adultNotValid: !(commonUtilities.isLeadingCorrectZero(this.props?.data?.markup?.adult ?? "") && this.validateValue(markupType, this.props?.data?.markup?.adult ?? "" )),
            childNotValid: !(commonUtilities.isLeadingCorrectZero(this.props?.data?.markup?.child ?? "") && this.validateValue(markupType, this.props?.data?.markup?.child ?? "" ))
        };
    }

    validateValue = (markupType, value) =>{
        if(value === undefined || value === null || value === "") return true;  // Empty value is allowed
        const num = parseFloat(value.replace(",", ""));
        if(isNaN(num) || num < 0) return false;
        if(markupType === CONSTANTS.MARKUP_TYPE_PERCENT && num > CONFIGURATION.CUSTOM_QUOTE_MARKUP_PERCENT_LIMIT) return false;
        if(markupType === CONSTANTS.MARKUP_TYPE_AMOUNT && num > CONFIGURATION.CUSTOM_QUOTE_MARKUP_AMOUNT_LIMIT) return false;
        return true;
    };

    isPositiveNumberWithCommas = (value) => {
        const regex = /^(?:\d{1,3}(?:,\d{3})*|\d+)(?:\.\d{1,2})?$/;
        let dd = regex.test(value.trim());
        return dd;
    };

    handleChangeMarkupType = (event) => {
        let { itinerary } = this.props.data;
        let itineraryNumber = itinerary?.itineraryNumber || 0;
        this.props.events.handleChangeMarkupType(event.target.value, itineraryNumber);
        this.setState({
            adult: undefined,
            child: undefined,
            adultNotValid: false,
            childNotValid: false
        });
    };

    handleBlur = (event, isAdult) => {
        let value = event.target.value;
        
        value = commonUtilities.removeEndDot(value);

        let { itinerary } = this.props.data;
        let itineraryNumber = itinerary?.itineraryNumber || 0;
        this.props.events.handleChangeMarkup(value, itineraryNumber, isAdult);
    };

    handleChange = (event, isAdult, markupType) => {

        const raw = event.target.value;

        // Allow empty string
        if (raw === "") {
            if(isAdult) this.setState({ adult: undefined, adultNotValid: false });
            else 
                this.setState({ child: undefined, childNotValid: false });
            return;
        }

        let testValue = raw;
        testValue = commonUtilities.appendZero(testValue);

        if(!this.isPositiveNumberWithCommas(testValue)){
            return;
        }

        if(!commonUtilities.isLeadingCorrectZero(raw)) {
            if(isAdult) {
                if(this.adultTimer) clearTimeout(this.adultTimer);
                this.setState({ adult: raw, adultNotValid: true });
            }
            else {
                if(this.childTimer) clearTimeout(this.childTimer);
                this.setState({ child: raw, childNotValid: true });
            }
        }
        else {
            // Convert to float and check range
            const num = parseFloat(testValue.replace(",", ""));
            
            if(isAdult) this.setState({ adult: raw, adultNotValid: ((markupType === CONSTANTS.MARKUP_TYPE_PERCENT && num > CONFIGURATION.CUSTOM_QUOTE_MARKUP_PERCENT_LIMIT) || (markupType === CONSTANTS.MARKUP_TYPE_AMOUNT && num > CONFIGURATION.CUSTOM_QUOTE_MARKUP_AMOUNT_LIMIT)) });
            else this.setState({ child: raw, childNotValid: ((markupType === CONSTANTS.MARKUP_TYPE_PERCENT && num > CONFIGURATION.CUSTOM_QUOTE_MARKUP_PERCENT_LIMIT) || (markupType === CONSTANTS.MARKUP_TYPE_AMOUNT && num > CONFIGURATION.CUSTOM_QUOTE_MARKUP_AMOUNT_LIMIT)) });
        }
    };

    render() {
        const { errors, data } = this.props;
        let { markup, referenceId, adultOnly } = data;
        let language = data?.language || "EN";

        if(!markup) return null;

        let markupType = markup?.type || CONSTANTS.MARKUP_TYPE_PERCENT;

        let inputsLabel = markupType === CONSTANTS.MARKUP_TYPE_PERCENT ? this.props.localize("qma-custom-quote-markup-inputs-percent-label") : this.props.localize("qma-custom-quote-markup-inputs-amount-label");
        let placeHolderLabel = markupType === CONSTANTS.MARKUP_TYPE_PERCENT ? this.props.localize("qma-custom-quote-markup-placeholder-percent") : this.props.localize("qma-custom-quote-markup-placeholder-amount");

        let { adult, child, adultNotValid, childNotValid } = this.state;
        let childWarning = false;
        let adultWarning = false;
        let childSurchargeWarning = false;
        let adultSurchargeWarning = false;
        let childWarningMessage = "";
        let adultWarningMessage = "";

        if(markupType === CONSTANTS.MARKUP_TYPE_PERCENT) {
            if(adult) {
                if(commonUtilities.toFloat(adult) > CONFIGURATION.CUSTOM_QUOTE_MARKUP_PERCENT_LIMIT) {
                    adultWarning = true;
                }
                // else {
                //     if(commonUtilities.toFloat(adult) > CONFIGURATION.CUSTOM_QUOTE_MARKUP_SURCHARGE_LIMIT) {
                //         adultSurchargeWarning = true;
                //         adultWarningMessage = this.props.localize("qma-markup-percent-surcharge-warning");
                //     }
                // }
            }
            if(child) {
                if(commonUtilities.toFloat(child) > CONFIGURATION.CUSTOM_QUOTE_MARKUP_PERCENT_LIMIT) {
                    childWarning = true;
                }
                // else {
                //     if(commonUtilities.toFloat(child) > CONFIGURATION.CUSTOM_QUOTE_MARKUP_SURCHARGE_LIMIT) {
                //         childSurchargeWarning = true;
                //         childWarningMessage = this.props.localize("qma-markup-percent-surcharge-warning");
                //     }
                // }
            }
            if(adultWarning) {
                adultWarningMessage = adultWarningMessage || this.props.localize("qma-markup-input-percent-warning");
            }
            if(childWarning) {
                childWarningMessage = childWarningMessage || this.props.localize("qma-markup-input-percent-warning");
            }
        }
        else {
            if(adult && commonUtilities.toFloat(adult) > CONFIGURATION.CUSTOM_QUOTE_MARKUP_AMOUNT_LIMIT) {
                adultWarning = true;
            }
            if(child && commonUtilities.toFloat(child) > CONFIGURATION.CUSTOM_QUOTE_MARKUP_AMOUNT_LIMIT) {
                childWarning = true;
            }
            if(adultWarning) {
                adultWarningMessage = adultWarningMessage || this.props.localize("qma-markup-input-amount-warning");
            }
            if(childWarning) {
                childWarningMessage = childWarningMessage || this.props.localize("qma-markup-input-amount-warning");
            }
        }

        let adultClassName = adultSurchargeWarning ? "surcharge-warning" : (adultNotValid ? "error": "");
        let childClassName = childSurchargeWarning ? "surcharge-warning" : (childNotValid ? "error": "");
        if(adultClassName.includes("error")) 
        { 
            adultWarningMessage = adultWarningMessage || this.props.localize("qma-number-not-valid");
        }
        if(childClassName.includes("error")) 
        { 
            childWarningMessage = childWarningMessage || this.props.localize("qma-number-not-valid");
        }

        let adultStartAdornment = null;
        let adultEndAdornment = null;
        let childStartAdornment = null;
        let childEndAdornment = null;
        
        if(markupType === CONSTANTS.MARKUP_TYPE_PERCENT) {
            adultEndAdornment = "%";
            childEndAdornment = "%";
        }
        else {
            if((adult || "").trim() === "") {
                adultEndAdornment = "$";                
            }
            else {
                adultStartAdornment = "$";
            }
            if((child || "").trim() === "") {
                childEndAdornment = "$";
            }
            else {
                childStartAdornment = "$";
            }
        }

        const tooltipOffset = CONSTANTS.BRAND_DEFAULT === process.env.REACT_APP_BRAND ? 8 : 16;

        return (
            <>
                <div>
                    { this.props.localize("qma-custom-quote-markup-by") }
                </div>
                <div className="margin-top-1x">
                    <RadioGroup
                        row
                        aria-labelledby="radio-buttons-group-label"
                        defaultValue={CONSTANTS.MARKUP_TYPE_PERCENT}
                        value={markupType}
                        name="all-itineraries-radio-buttons-group"
                        onChange={this.handleChangeMarkupType}
                    >
                        <FormControlLabel value={CONSTANTS.MARKUP_TYPE_PERCENT} control={<Radio />} label={ this.props.localize("qma-custom-quote-markup-by-percent") } />
                        <FormControlLabel value={CONSTANTS.MARKUP_TYPE_AMOUNT} control={<Radio />} label={ this.props.localize("qma-custom-quote-markup-by-amount") }  />
                    </RadioGroup>
                </div>
                <div className="margin-top-3x">
                    <div>{inputsLabel}</div>
                    <div className="d-flex margin-top-1x">
                        <div className="col-markup-label">
                            <strong>{ this.props.localize("qma-input-label-adult") }</strong>
                        </div>
                        <div className="col-markup-input">
                            <div className="row form-control-wrapper">
                                <OutlinedInput
                                    fullWidth
                                    type="text"
                                    name="adult"
                                    className={ adultClassName }
                                    placeholder={placeHolderLabel}
                                    id={"outlined-adult-" + referenceId}
                                    value={adult ?? ""}
                                    startAdornment={adultStartAdornment === null ? null : <InputAdornment position="start">{adultStartAdornment}</InputAdornment>}
                                    endAdornment={adultEndAdornment === null ? null: <InputAdornment position="end">{adultEndAdornment}</InputAdornment>}
                                    inputProps={{ maxLength: 13, inputMode: "decimal" }}
                                    onBlur={(event) => this.handleBlur(event, true)}
                                    onChange={(event) => this.handleChange(event, true, markupType)}
                                    aria-describedby={"outlined-adult-" + referenceId}
                                    data-tooltip-id={"adult-warning-" + referenceId}
                                    data-tooltip-content={adultWarningMessage}
                                    data-tooltip-delay-hide={ 5000 }
                                    error={adultWarningMessage ? true : false}
                                    sx={{
                                        backgroundColor: adult ? "var(--lavender-blue)" : "transparent",
                                        "& .MuiInputAdornment-root.MuiInputAdornment-positionStart, & .MuiInputAdornment-root.MuiInputAdornment-positionEnd": {
                                            backgroundColor: adult ? "var(--lavender-blue)" : "transparent"
                                        },
                                        "&.Mui-error .MuiInputAdornment-root.MuiInputAdornment-positionStart, &.Mui-error .MuiInputAdornment-root.MuiInputAdornment-positionEnd": {
                                            backgroundColor: "var(--lavender-blue) !important"
                                        }
                                    }}
                                />
                                <Tooltip 
                                    id={"adult-warning-" + referenceId}
                                    place="top-end"
                                    offset={tooltipOffset}  
                                    className="tool-tip-markup-warning"
                                    isOpen={(adultWarning || adultNotValid || adultSurchargeWarning)}
                                />
                            </div>
                            
                        </div>
                    </div>
                    { adultOnly ? null : 
                        <div className="d-flex margin-top-1x">
                            <div className="col-markup-label">
                                <strong>{ this.props.localize("qma-input-label-child") }</strong>
                            </div>
                            <div className="col-markup-input">
                                <div className="row form-control-wrapper">
                                    <OutlinedInput
                                        fullWidth
                                        type="text"
                                        name="child"
                                        className={ childClassName }
                                        placeholder={placeHolderLabel}
                                        id={"outlined-child-" + referenceId}
                                        value={child ?? ""}
                                        startAdornment={childStartAdornment === null ? null : <InputAdornment position="start">{childStartAdornment}</InputAdornment>}
                                        endAdornment={childEndAdornment === null ? null: <InputAdornment position="end">{childEndAdornment}</InputAdornment>}
                                        inputProps={{ maxLength: 13, inputMode: "decimal" }}
                                        onBlur={(event) => this.handleBlur(event, false)}
                                        onChange={(event) => this.handleChange(event, false, markupType)}
                                        aria-describedby={"outlined-child-" + referenceId}
                                        data-tooltip-id={"child-warning-" + referenceId}
                                        data-tooltip-content={childWarningMessage}
                                        error={childWarningMessage ? true : false}
                                        sx={{
                                            backgroundColor: child ? "var(--lavender-blue)" : "transparent",
                                            "& .MuiInputAdornment-root.MuiInputAdornment-positionStart, & .MuiInputAdornment-root.MuiInputAdornment-positionEnd": {
                                                backgroundColor: child ? "var(--lavender-blue)" : "transparent"
                                            },
                                            "&.Mui-error .MuiInputAdornment-root.MuiInputAdornment-positionStart, &.Mui-error .MuiInputAdornment-root.MuiInputAdornment-positionEnd": {
                                                backgroundColor: "var(--lavender-blue) !important"
                                            }
                                        }}
                                    />
                                    <Tooltip 
                                        id={"child-warning-" + referenceId}
                                        place="bottom-end"
                                        offset={tooltipOffset}  
                                        className="tool-tip-markup-warning"
                                        isOpen={(childWarning || childNotValid || childSurchargeWarning)}
                                    />
                                </div>
                                
                            </div>
                        </div>
                    }
                </div>
            </>
        );
    }
}

export default withLocalizer(Markup);